import React from "react";
import Navbar from "./ui/Navbar";

export default function Home() {
  return (
    <div className="relative min-h-screen overflow-hidden text-white">
      {/* Ambient accent glow for depth */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-40 left-1/2 h-[28rem] w-[28rem] -translate-x-1/2 rounded-full bg-accent/10 blur-3xl"
      />
      <div className="relative pb-16 sm:pb-24">
        <Navbar />

        <main className="mt-16 sm:mt-24">
          <div className="mx-auto max-w-3xl px-4 text-center">
            <h1 className="font-display text-4xl font-bold leading-tight tracking-tight sm:text-5xl md:text-7xl">
              Process your <span className="text-accent">sound with AI</span>
            </h1>
            <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-white/70 sm:text-xl">
              Our cloud-based AI-driven audio processor uses advanced machine
              learning techniques to enhance the quality of audio signals. With
              a simple interface, users can easily improve the sound of their
              recordings, to make all sound like major market media companies.
              Try it out today and experience the power of AI-enhanced audio.
            </p>
          </div>
        </main>
      </div>
    </div>
  );
}
